import Humanize from "humanize-plus";
import { parseFloatToSizeLimit } from "./validators";

export const numberOrDashForRate = ({
    value,
    validFunc = (v) => true,
    replacement = "-",
}) => {
    if (!value && value !== 0) return replacement;
    if (isNaN(value) || isNaN(parseFloat(value))) return value;
    if (!validFunc(value)) return value;
    return parseFloatToSizeLimit(value);
};
export const numberOrDash = ({
    value,
    validFunc = (v) => true,
    humanize = true,
    replacement = "-",
}) => {
    if ((!value && value !== 0) || isNaN(value)) return replacement;
    if (!validFunc(value)) return value;
    return humanize
        ? Humanize.formatNumber(value, 2)
        : parseFloat(value).toFixed(2);
};

export const intOrDash = ({
    value,
    validFunc = (v) => true,
    humanize = true,
    replacement = "-",
}) => {
    if ((!value && value !== 0) || isNaN(value)) return replacement;
    if (!validFunc(value)) return value;
    return humanize ? Humanize.intComma(parseInt(value)) : parseInt(value);
};

export const pickValidNumber = (x, y) => {
    const parsedX = parseFloat(x);
    const parsedY = parseFloat(y);
    if (isNaN(parsedX) && isNaN(parsedY)) return x;
    return isNaN(parsedX) ? parsedY : parsedX;
};
